var cibZulip = ["32 32", "<path d='M32 16c0 8.839-7.161 16-16 16s-16-7.161-16-16c0-8.839 7.161-16 16-16s16 7.161 16 16zM21.292 8h-11.932l1.333 2.708h8.078l-9.411 10 1.333 3.276h11.948l-1.333-2.693h-8.094l9.411-10-1.333-3.276z'/>"];

export { cibZulip };

